import styled from 'styled-components';

const Card = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 1rem 2rem;
    display: flex;
    justify-content: center;
`;

const Loader = styled.div`
    color: rgb(124, 124, 124);
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    font-size: 25px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    height: 40px;
    padding: 10px 10px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    border-radius: 8px;
`;

const Words = styled.div`
    overflow: hidden;
    position: relative;
    
    &::after {
        content: "";
        position: absolute;
        inset: 0;
        z-index: 20;
    }
`;

const Word = styled.span`
    display: block;
    height: 100%;
    padding-left: 6px;
    color: #009373;
    animation: spin_4991 4s infinite;

    @keyframes spin_4991 {
        10% {
            transform: translateY(-102%);
        }
    
        25% {
            transform: translateY(-100%);
        }
    
        35% {
            transform: translateY(-202%);
        }
    
        50% {
            transform: translateY(-200%);
        }
    
        60% {
            transform: translateY(-302%);
        }
    
        75% {
            transform: translateY(-300%);
        }
    
        85% {
            transform: translateY(-402%);
        }
    
        100% {
            transform: translateY(-400%);
        }
    }
`;

export { Card, Loader, Words, Word };